import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import FAQs from './pages/FAQs';
import Contact from './pages/Contact';
import Franchising from './pages/Franchising';
import MenuPage from './pages/Menu';
import Checkout from './pages/Checkout';
import TrackOrder from './pages/TrackOrder';
import Reorder from './pages/Reorder';
import MyOrders from './pages/MyOrders';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SideSocial from './components/SideSocial';
import CartDrawer from './components/CartDrawer';
import { Toaster } from './components/ui/toaster';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminMessages from './pages/admin/AdminMessages';
import AdminFranchise from './pages/admin/AdminFranchise';
import AdminMenu from './pages/admin/AdminMenu';
import AdminModifiers from './pages/admin/AdminModifiers';
import AdminCategories from './pages/admin/AdminCategories';
import AdminDeals from './pages/admin/AdminDeals';
import AdminHours from './pages/admin/AdminHours';
import AdminOrders from './pages/admin/AdminOrders';
import AdminCustomers from './pages/admin/AdminCustomers';
import AdminSettings from './pages/admin/AdminSettings';
import AdminKitchen from './pages/admin/AdminKitchen';
import AdminPrinter from './pages/admin/AdminPrinter';
import AdminKitchenTV from './pages/admin/AdminKitchenTV';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';

function PublicShell({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  if (isAdmin) return children;
  return (
    <>
      <Navbar />
      <SideSocial />
      <CartDrawer />
      {children}
      <Footer />
    </>
  );
}

function AppShell() {
  // Capture referral code from URL and remember it
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) {
      localStorage.setItem('wrappus_ref', ref.toUpperCase().slice(0, 12));
    }
  }, []);
  return (
    <PublicShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/franchising" element={<Franchising />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/track/:orderId" element={<TrackOrder />} />
        <Route path="/reorder/:orderId" element={<Reorder />} />
        <Route path="/my-orders" element={<MyOrders />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/kitchen-tv" element={<AdminKitchenTV />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="messages" element={<AdminMessages />} />
          <Route path="franchise" element={<AdminFranchise />} />
          <Route path="menu" element={<AdminMenu />} />
          <Route path="modifiers" element={<AdminModifiers />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="deals" element={<AdminDeals />} />
          <Route path="hours" element={<AdminHours />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="customers" element={<AdminCustomers />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="kitchen" element={<AdminKitchen />} />
          <Route path="printer" element={<AdminPrinter />} />
        </Route>
      </Routes>
    </PublicShell>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppShell />
            <Toaster />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
